import {Card, CardContent, FlexContainer} from "@axxes/design-system";
import React from "react";
import {EditSchools} from "../components/EditSchools/EditSchools";

export const ManageSchoolDataContainer = () => {
    return <FlexContainer
        direction="column"
        customClasses="axxes-manage__edit"
        padding="0"
    >
        <FlexContainer
            direction="row"
            padding="0"
        >
            <h1>Manage School Data</h1>
        </FlexContainer>
        <FlexContainer
            direction="column"
            padding="0"
            customClasses="axxes-manage__card"
        >
            <Card>
                <CardContent>
                    <EditSchools/>
                </CardContent>
            </Card>
        </FlexContainer>
    </FlexContainer>
}